.ux-iws-stateful-filter {
    ux-select {
        width: 100%;
    }

    .ux-date-range-picker__separator {
        flex: 0 0 30px;
    }

    .ux-row--hidden {
        display: none;
    }

    form {
        margin-bottom: 0;
    }

    &__spinner {
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.7);
        display: flex;
        align-items: center;
        position: absolute;
        z-index: 1;
        display: none;

        &.is-active {
            display: flex;
        }
    }
}
